import {WaitingModal} from "./waiting.modal";
import {Injectable} from "@angular/core";
import {AsiDialog, AsiDialogService} from "@asi-ngtools/lib";

@Injectable()
export class WaitingModalService {

    private _dialog: AsiDialog<WaitingModal>;

    constructor(private dialogService: AsiDialogService) {
    }

    openModal(title?: string) {
        if (this._dialog != null) {
            this._dialog.close();
        }
        this._dialog = this.dialogService.fromComponent(WaitingModal, null);
        if (title != null) {
            this._dialog.getComponent().titre = title;
        }
    }

    closeModal() {
        if (this._dialog != null) {
            this._dialog.close();
            this._dialog = null;
        }
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/modal/waiting/waiting.service.ts